/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";

const LpCivilLawAdvocardMeta = () => {
  const title = "Fragen oder Probleme bei rechtlichen Streitigkeiten im Alltag? l Legalbird";

  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Fragen oder Probleme bei rechtlichen Streitigkeiten im Alltag?" />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Fragen oder Probleme bei rechtlichen Streitigkeiten im Alltag?" />
    </Helmet>
  );
};

export default LpCivilLawAdvocardMeta;
